






















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Unit from "../../../store/entities/unit";

@Component
export default class AssignEmployee extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  employeeId: number = 0;
  plIds : [];

  get employees() {
    var list = this.$store.state.user.employees;
    return list;
  }
  save() {
    (this.$refs.assignEmployeeForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.employeeId == 0){
          Util.showErrorMsg(this, "Employee is required.");
          return;
        }
        else{
          await this.$store.dispatch({
            type: "picklist/assign",
            data: {
              employeeId : this.employeeId,
              pickListIds : this.plIds,
            }
          }).then((re) => {
            if(re.warningMessage != ''){
              Util.showWarningMsg(this,re.warningMessage);
            }
            else{
              Util.showSuccessMsg(this,"Success.AssignEmployeeSuccess");
            }
            
          });
          this.$emit("save-success");
          this.$emit("input", false);
          
        }
      }
    });
  }
  cancel() {
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if(!value){
      this.$emit("input", value);
    }
    if (value) {
      this.plIds = this.$store.state.picklist.plIdsSelected;
    }
  }
}
